import * as types from "../types/menus";

const INITIAL_STATE = {
  modulos: [],
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.MENUS_SET_MODULOS:
      return { ...state, modulos: action.payload };
    default:
      return state;
  }
};
